import { FC } from "react";

const DropdownPossibleNextStep: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown">
      <button className="btn btn-link nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
        Possible "Next Steps"
      </button>

      <ul className="colors-dropdown dropdown-menu dropdown-menu-end p-4">
        <p className="m-0">
          On the case screen, you can see a new column labeled "Next Steps" ...
          These new options allow you to update your cases without the need to contact us.
          The actions available are as follows:
        </p>
        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-6">
              <span className="btn background-color-5 my-1 text-white ms-3">
                <i className="fas fa-clipboard-list"></i> Precert
              </span>
            </div>
            <div className="col-sm-6">
              Clicking "Precert" allows you to upload clinicals and enter information for the precert as well as
              submit it to the plan or request it be completed on your behalf.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-6">
              <span className="btn btn-success my-1 text-white ms-3">
                <i className="far fa-clipboard"></i> Date of Treatment
              </span>
            </div>
            <div className="col-sm-6">
              Clicking "Date of Treatment" Allows you to specify the date the patient was treated
            </div>
          </div>
        </li>
      </ul>
    </li>
  );
};

export default DropdownPossibleNextStep;
